import { Dates } from "src/modules/utils/shared/dates";
import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { ComponentView } from 'src/modules/app-template/models/component-view.model';
import { RestEndpoint } from 'src/modules/sm-base/models/rest-endpoint.model';
import { TableCellType } from 'src/modules/sm-base/netgen/TableCellType';
import { TableColumn } from 'src/modules/sm-base/netgen/TableColumn';
import { TableData } from 'src/modules/sm-base/models/table-data.model';
import { TableRow } from 'src/modules/sm-base/models/table-row.model';
import { TableSortColumn } from 'src/modules/sm-base/models/table-sort-column.model';
import { Utils } from 'src/modules/utils/shared/utils';
import { EnaioCertificateService } from '../../services/enaio-certificate.service';
import { Course } from '../../shared/course.entity';
import { EnaioCertificatesTools } from '../../shared/enaio-certificates-tools';
import { ObjectOfSimpleDataTypes } from 'src/modules/utils/shared/object-of-simple-data-types.model';
import { Arrays } from 'src/modules/utils/shared/arrays';
import { Objects } from "src/modules/utils/shared/objects";

@Component({
    selector: 'app-edit-class-courses',
    templateUrl: './edit-class-courses.component.html',
    styleUrls: ['./edit-class-courses.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EditClassCoursesComponent extends ComponentView {

    service = inject(EnaioCertificateService);

    neededParams: ObjectOfSimpleDataTypes = { year: "number?" };
    year: number;

    listData: Course[];
    table: TableData;

    showFinishedCourses = false;

    async initParams(): Promise<boolean> {
        this.year = Utils.toNumber(this.year ?? EnaioCertificatesTools.getCurrentYear());
        this.listData = await this.app.loadDataHandler(async () => RestEndpoint.main().query({year: this.year, isHalfYear: false}).run("api/cer/classregister/courses").list(Course), this);
        
        this.updateTable();

        this.app.updateNavigation("Kursbuch", [
            this.service.getHomeCourses()
        ]);
        return true;
    }

    updateTable(): void {
        this.table = new TableData([
            new TableColumn("type", "Schulzweig", TableCellType.string, 20),
            new TableColumn("title", "Bezeichnung", TableCellType.string, 30),
            new TableColumn("group", "Gruppe", TableCellType.string, 30),
            new TableColumn("grades", "Klassenstufen", TableCellType.string, 30),
            new TableColumn("instructor", "Kursleiter", TableCellType.string, 20),
            new TableColumn("endDate", "Enddatum", TableCellType.date, 1),
            new TableColumn("forCertificate", "Zeugnisrelevant", TableCellType.bool, 1)
        ], this.listData.filter(item => this.showFinishedCourses || !item.isFinished()).map(item => new TableRow("", item, {
            type: Arrays.getSafe(EnaioCertificatesTools.getSchoolTypeNames(), item.type, Objects.toString(item.type)),
            title: item.title,
            group: item.group,
            grades: Arrays.itemsToString(item.forGrades),
            instructor: item.instructor,
            endDate: item.endDate,
            forCertificate: item.forCertificate
        })), ["type", "title"]);

    }
}
